import cn from 'classnames';
import type React from 'react';
import { forwardRef } from 'react';
import * as st from './styles.module.scss';

export type IconButtonVariant =
  | 'outlined'
  | 'dark'
  | 'transparent'
  | 'active'
  | 'activeDark'
  | 'light'
  | 'secondary'
  | 'mobile'
  | 'white'
  | 'darkLight';

export interface IconButtonPT extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: IconButtonVariant;
  smallVariant?: IconButtonVariant;
  borderVariant?: 'round' | 'square';
  size?: 'small' | 'medium' | 'medium-large' | 'large' | 'agreement';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonPT>(
  (
    {
      variant = 'dark',
      size = 'medium',
      smallVariant,
      borderVariant = 'round',
      children,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <button
        tabIndex={props.tabIndex}
        ref={ref}
        className={cn(
          className,
          st.btn,
          st[size],
          st[variant],
          st[borderVariant],
          st[`${smallVariant}-sm`]
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);
